import React from 'react'
import c from 'classnames'
import { connect } from 'react-redux'

import Menuing from 'components/widgets/Menuing'

import { money } from 'utils'
import { getQuoteValue } from 'selectors/quoteSelectors'
import { changeQuote } from 'actions/quoteActions'
import { getPermission } from 'selectors/authSelectors'

import './Additions.scss'

const PERM = 'deal.collection/adds'

export function GenericAdditions({
  vehicleId,
  quoteId,
  additions,
  className,
  addsKey,
  title,
  changeQuote,
}) {
  if (!additions || !additions.length) return null

  let toggleAdd = (c, i) =>
    !c.required &&
    changeQuote(vehicleId, quoteId, {
      [`${addsKey}[${i}].include`]: !c.include,
    })

  return (
    <div className={c('quote-additions', `quote-${addsKey}`, className)}>
      <h3>{title || addsKey}</h3>
      <Menuing
        items={additions}
        onClick={toggleAdd}
        labelRenderer={c => {
          return (
            <React.Fragment>
              <span className="addition-name">
                <input
                  type="checkbox"
                  checked={c.include}
                  disabled={c.required}
                  onChange={() => {}}
                />
                {c.name}
              </span>
              <span className="addition-description">{c.description}</span>
            </React.Fragment>
          )
        }}
        valueRenderer={c => {
          let discount = Math.floor(100 - (c.price / c.retail) * 100)

          return (
            <React.Fragment>
              <span className="addition-price">
                <span className="addition-price-value">
                  Your Price: {money(c.price)}
                </span>
              </span>
              <span className="addition-retail">
                {discount > 0 && (
                  <span className="discount">
                    {discount === 100 ? 'FREE!' : `${discount}% off!`}
                  </span>
                )}
                <span className="addition-retail-value">
                  Retail: {money(c.retail)}
                </span>
              </span>
            </React.Fragment>
          )
        }}
      />
    </div>
  )
}

function mapStateToProps(state, op) {
  return {
    ...op,
    additions: getQuoteValue(
      state,
      op.vehicleId,
      op.quoteId,
      op.addsKey,
    ).filter(a => a && a.show),
    permission: getPermission(state, PERM),
  }
}

export default connect(
  mapStateToProps,
  { changeQuote },
)(GenericAdditions)
